/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrdersLookupForTenders.ts        *
 *                                                                             *
/*******************************************************************************/
import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";
const endpointPath = "lme/datafusion/orders-lookup-for-tenders";
export class AutogenModelOrdersLookupForTenders<RowType extends ModelRow> extends Endpoint<RowType, RowOrdersLookupForTendersFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}
export class AutogenRowOrdersLookupForTenders extends ModelRow<RowOrdersLookupForTendersFields> {
	constructor(values?: Partial<RowOrdersLookupForTendersFields>) {
		super(endpointPath, true, values);
	}
}
export interface RowOrdersLookupForTendersFields {
	id: string;
	status: string;
	search_shipment_id: string;
}
